import { HoloHelmet } from 'common-js/components';
import { type FC } from 'react';
import { type RouteComponentProps } from 'react-router';
import { getCustomPostpaid } from 'common-js/reducers/organization/selectors';
import useAppSelector from 'common-js/hooks/useAppSelector';
import CustomPostpaidDisclaimer from 'components/CustomPostpaidDisclaimer/CustomPostpaidDisclaimer';
import DataPlans from './DataPlans';

interface PlansProps extends RouteComponentProps<{}, RouterQueryParams> {}

const Plans: FC<PlansProps> = () => {
  const isCustomPostpaid = useAppSelector(getCustomPostpaid);
  return (
    <>
      <HoloHelmet title="Data plans" />

      <div className="billing-container billing-plans SimsTagManager">
        {isCustomPostpaid && <CustomPostpaidDisclaimer />}
        <DataPlans />
      </div>
    </>
  );
};

export default Plans;
